import styled from 'styled-components';

export const ContextMenuDiv = styled.div<{ isHidden?: boolean }>`
  padding: 8px 4px;
  background-color: var(--color-bg-primary);
  border-radius: 10px;
  box-shadow: var(--shadow-md);

  ${(props) => props.isHidden && `display: none;`}
`;
